import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import BACKEND_URL from '../../config';

class EmployeeList extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      employees: []
    };
  }
  componentDidMount = () => {
    fetch(`${BACKEND_URL}/employees`)
      .then(res => res.json())
      .then(employees => {
        return this.setState({ employees: employees });
      });
  }
  deleteEmployee = (employeeId) => {
    fetch(`${BACKEND_URL}/employees/${employeeId}`, {
      method: "DELETE"
    })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          this.setState({ employees: this.state.employees.filter(employee => employee.id !== employeeId)});
        }
      })
      .catch(function(err) {
        console.log(err);
      });
  }
  render = () => {
    if (this.state.redirectAdmin) {
        return <Redirect to="/" />;
    }
    return (
      <div className="Employees">
        <ul className="list pl0 mt0 measure center h6 overflow-y-scroll">
          {this.state.employees.map(employee => (
            <li
              className="flex items-center lh-copy pa3 ph0-l bb b--black-10"
              key={employee.id}>
              <Link to={`/employee-card/${employee.id}`}>
                <img
                  className="br3 ba b--black-10 h3 w3"
                  src={employee.url}
                  alt="employee avatar"
                />
              </Link>
              <div className="pl3 flex-auto">
                <span className="f6 db black-70">
                  {employee.first_name} {employee.last_name}
                </span>
                <span className="f6 db black-70">{employee.position}</span>
                <span className="f7 db black-70">{employee.department}</span>
              </div>
              <div>
                <a className="f6 link blue hover-dark-gray" onClick={() => this.deleteEmployee(employee.id)}>Remove</a>
                <br/>
                <Link className="f6 link blue hover-dark-gray" to={`/edit-employee/${employee.id}`}>
                  <span>Edit</span>
              </Link>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default EmployeeList;



// WEBPACK FOOTER //
// ./src/components/employee/EmployeeList.js